import { create } from "zustand";

/** Whether the demo's guided tour is on screen. The banner starts it, the tour ends it. */
interface DemoTourState {
  running: boolean;
  start: () => void;
  stop: () => void;
}

export const useDemoTour = create<DemoTourState>()((set) => ({
  running: false,
  start: () => set({ running: true }),
  stop: () => set({ running: false }),
}));
